import { useInView } from 'react-intersection-observer';
import joshImgWebp from '../assets/josh.webp';
import joshImg from '../assets/josh.png';

const About = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
    delay: 200,
  });

  return (
    <section
      ref={ref}
      id="about"
      className={`py-16 px-4 sm:px-6 lg:px-8 relative
                 transition-all duration-1000 ease-out transform
                 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
    >
      <div className="max-w-7xl mx-auto">
        <h2 className={`brand-header text-3xl sm:text-4xl font-bold font-sans text-center mb-16 transition-opacity duration-1000 ${inView ? 'opacity-100' : 'opacity-0'}`}>
          About Utopian Creations
        </h2>

        <div className="md:flex md:items-start md:gap-12">
          {/* Image Column */}
          <div className={`md:w-1/3 mb-8 md:mb-0 transition-all duration-1000 ease-out ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
            <picture>
              <source srcSet={joshImgWebp} type="image/webp" />
              <img
                src={joshImg}
                alt="Joshua Miller, Founder of Utopian Creations"
                className="rounded-lg shadow-lg w-full mx-auto md:mx-0"
                style={{ maxWidth: '320px' }}
              />
            </picture>
          </div>

          {/* Text Content Column */}
          <div className={`md:w-2/3 transition-all duration-1000 ease-out ${inView ? 'opacity-100' : 'opacity-0'}`}>
            <h3 className="brand-subheader text-2xl font-bold font-sans mb-4">
              Joshua Miller — Founder & Developer
            </h3>
            <p className="font-sans mb-4 leading-relaxed text.body">
              I started Utopian Creations because small businesses deserve the same caliber of technology that enterprise companies get — without the six-figure agency price tag. I've shipped apps to both app stores, built marketplaces from scratch, and helped local businesses establish a real digital presence. Every project I take on gets my full attention — not a junior developer's.
            </p>
            <p className="font-sans mb-4 leading-relaxed text.body">
              I leverage advanced development tooling as a force multiplier — not to cut corners, but to deliver more value in less time. Every project is custom-scoped to your actual needs and budget. The result: you get a product that would take a traditional team months, delivered in weeks.
            </p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-purple-50 rounded-lg p-4 text-center">
                <p className="text-2xl font-bold text-purple-700">5+</p>
                <p className="text-sm text.body">Products Shipped</p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4 text-center">
                <p className="text-2xl font-bold text-purple-700">7+</p>
                <p className="text-sm text.body">Years in Tech</p>
              </div>
              <div className="bg-purple-50 rounded-lg p-4 text-center">
                <p className="text-2xl font-bold text-purple-700">2</p>
                <p className="text-sm text.body">App Stores</p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Philosophy */}
        <div className={`mt-16 border-l-4 border-purple-500 bg-purple-50 rounded-r-xl p-8 transition-all duration-1000 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h3 className="brand-subheader text-2xl font-bold font-sans mb-4">
            How I use AI (and where I don't)
          </h3>
          <p className="font-sans leading-relaxed text.body mb-4">
            I use AI the way a good carpenter uses a nail gun: it makes the routine work fast, it doesn't decide what to build. Every line of code that ships goes through me. I read it, test it, and I'm the one who answers when something breaks.
          </p>
          <p className="font-sans leading-relaxed text.body">
            That's how a site goes live on a 60-minute call without cutting corners: the scaffolding is automated, the decisions are not. The time saved goes into understanding your business and solving the problems a template can't.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
